import { Component, input, output } from '@angular/core'

import { DiscountType } from '../charges-table-form.types'

@Component({
  selector: 'mmx-discount-menu-button',
  templateUrl: './discount-menu-button.component.html',
  standalone: false,
})
export class DiscountMenuButtonComponent {
  readonly DiscountType = DiscountType
  readonly discountInputAdded = input.required<boolean>()
  readonly discountSelected = output<{ type: DiscountType }>()
  readonly removeDiscountControl = output<void>()

  onDiscountSelect(type: DiscountType): void {
    this.discountSelected.emit({ type })
  }
}
